import clsx from 'clsx';
import { Link } from 'gatsby';
import * as React from 'react';

import { Button } from '@components/Button';
import { SVGIcon } from '@components/SVGIcon';

import * as styles from './styles.module.scss';

interface NavigationProps {
	buttonInverted?: boolean;
	ctaText: string;
	menuLinks: {
		href: string;
		title: string;
	}[];
}

export const Navigation: React.FunctionComponent<NavigationProps> = ({ menuLinks, ctaText, buttonInverted }) => {
	const [menuOpen, setMenuOpen] = React.useState(false);
	const handleClick = React.useCallback(() => setMenuOpen(!menuOpen), [menuOpen]);

	return (
		<div className={styles.menu}>
			<div className={clsx(styles.menuHandle, buttonInverted && styles.inverted)} onClick={handleClick}><SVGIcon name="bars" /></div>
			<div className={clsx(styles.menuLinks, menuOpen && styles.active)}>
				<div className={styles.menuHeader}>
					<Button role="textual" type="button" inverted={true}>
						{ctaText}
					</Button>
					<div className={styles.menuHandle} onClick={handleClick}>
						<SVGIcon name="times" />
					</div>
				</div>
				<div className={styles.linkList}>
					{menuLinks.map(({ href, title }) => ((/^\/(?!\/)/u).test(href) ? <Link to={href} onClick={handleClick}>{title}</Link> : <a key={`${href}-${title}`} href={href} onClick={handleClick}>{title}</a>))}
				</div>
			</div>
		</div>
	);
};
